import React from "react";
import { extractAppliedFilters } from "src/utils/algoliaFiltersHelper";
import {
  appliedFilterForKey,
  destinationNameSortingTransformer
} from "./utils";

import DropDownFilter from "../DropDownFilter";
import RefinementListFilter from "../RefinementListFilter";
import { FYCFiltersProps } from "./types";
import { t, Trans } from "@lingui/macro";

const DestinationFilter: React.FC<FYCFiltersProps> = ({
  searchState,
  expanded,
  toggleVisibleComponent
}) => {
  const appliedFilters = extractAppliedFilters(searchState);
  const appliedDestinationFilter = appliedFilterForKey(
    appliedFilters.refinementList,
    "destinationName"
  );

  return (
    <DropDownFilter
      label={t`Destination`}
      onExpandToggle={(e) => toggleVisibleComponent("destination", e)}
      expanded={expanded}
      count={appliedDestinationFilter.length}
      dataContentPiece="destination_filter_interaction"
    >
      <div className="ssc-filters--filter-title">
        <Trans>Choose the Destination</Trans>
      </div>
      <RefinementListFilter
        attribute="destinationName"
        operator="or"
        transformItems={destinationNameSortingTransformer()}
        limit={100}
      />
    </DropDownFilter>
  );
};

export default DestinationFilter;
